import "./ListingEditor.css";
import { useEffect, useState, useRef, useContext } from "react";
import {Button, Modal, Dropdown} from '@nxtvid/component-library'
import ConfirmModal from "../../Components/Confirm Modal/ConfirmModal";
import { UserContext } from "../../Contexts/UserContext";
import ToggleButton from "../../Components/ToggleButton/ToggleButton";
import { AuthContext } from "../../Contexts/AuthContext";


const ListingEditor = () => {
  const [listingInfo, setListingInfo] = useState(null);
  const [videoFile, setVideoFile] = useState(null)
  const [isUploading, setIsUploading] = useState(false);
  const [uploadUrl, setUploadUrl] = useState('');
  const [progress, setProgress] = useState(0);
  const [savedListingInfo, setSavedListingInfo] = useState(null)
  const [selectedPricingTier, setSelectedPricingTier] = useState(null)
  const uploadIcon = require('../../Images/uploadIcon.png')
  const cities = ["Miami", "New York", "Los Angeles"]
  const pricingTiers = ['Value', 'Mid-Range', 'High-End']
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedVideo, setSelectedVideo] = useState(null)
  const [isUploadInProgress, setIsUploadInProgress] = useState(false);
  const [aboutImage, setAboutImage] = useState(null)
  const [logo, setLogo] = useState(null)
  const targetSection = useRef(null);
  const [isNameBeingUsed, setIsNameBeingUsed] = useState(false)
  const [isUrlBeingUsed, setIsUrlBeingUsed] = useState(false)
  const [isListingUpdating, setIsListingUpdating] = useState(false)
  const [isListingUpdatingCardVisible, setIsListingUpdatingCardVisible] = useState(false)
  const [listingUpdatingText, setListingUpdatingText] = useState('Updating Listing.')
  const [aboutImg, setAboutImg] = useState(null)
  const [aboutImgUrl, setAboutImgUrl] = useState(null)
  const [logoUrl, setLogoUrl] = useState(null)
  const[demoReelCategories, setDemoReelCategories] = useState([])
  const [newAboutImage, setNewAboutImage] = useState(false)
  const [newLogo, setNewLogo] = useState(false)
  const { userInfo, setUserInfo } = useContext(UserContext);
  const {isAuthenticated} = useContext(AuthContext)

// Modal States
      const [isModalOpen, setIsModalOpen] = useState(false)
      const [modalType, setModalType] = useState('confirm')
      const [modalSize, setModalSize] = useState('medium')
      const [modalTitle, setModalTitle] = useState('')
      const [modalDescription, setModalDescription] = useState('' )
      const [modalOnConfirm, setModalOnConfirm] = useState(() => () => {})
      const [modalOnCancel, setModalOnCancel] = useState(() => () => {})
      const [modalConfirmButtonText, setModalConfirmButtonText] = useState('')
      const [modalCancelButtonText, setModalCancelButtonText] = useState('')
      const [modalChildren, setModalChildren] = useState(null) 
      
  
  let intervalId;

  
  
  useEffect(() => { 
    if (isAuthenticated === null) return; 

    if (!userInfo.isVideographer) {
      window.location.href = '/';
    }
  }, [userInfo]);
  
  

  // Grab url and about image
    useEffect(() => {
      const fetchAboutImageUrl = async () => {
        try {
          const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
          const filePath = listingInfo.aboutImg.split('/').pop();
      
          const response = await fetch(`${API_BASE_URL}/get-logo-about-image`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ filePath }),
          });
      
          const data = await response.json();
          setAboutImg(data.signedUrl);
        } catch (error) {
          console.error("Error fetching image:", error);
        }
      };
      
  
  
      
      const fetchLogoUrl = async () => {
        if(newLogo) return
        try {
          const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
          const filePath = listingInfo.companyLogo.split('/').pop();
      
          const response = await fetch(`${API_BASE_URL}/get-logo-about-image`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ filePath }),
          });
      
          const data = await response.json();
          setLogo(data.signedUrl);
        } catch (error) {
          console.error("Error fetching image:", error);
        }
      };
      
  
      if (listingInfo?.aboutImg) {
        fetchAboutImageUrl();
      }
      if(listingInfo?.companyLogo){
        fetchLogoUrl();
      }
    }, [listingInfo]);

  const viewVideo = async (filePath) => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
    try {
      const response = await fetch(`${API_BASE_URL}/get-signed-url-video`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Secure API secret
        },
        body: JSON.stringify({ filePath: filePath }), // Send data in request body
      });
      const data = await response.json();
      window.open(data.url, '_blank');
  } catch (error) {
      console.error("Error fetching signed URL:", error);
  }
  }

  const handleTogglePackagesVisibility = () => {
    const tempListingInfo = { ...listingInfo };
    tempListingInfo.packagesVisible = !tempListingInfo.packagesVisible ? true : false;
    setListingInfo(tempListingInfo);
  }
  
  const getListingInfo = async () => {
    try {
      if (!userInfo?.listingId) return; // Ensure listingId is valid
      const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
      const response = await fetch(`${API_BASE_URL}/api/getListingInfo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
        },
        body: JSON.stringify({ listingId: userInfo.listingId }),
      });
      const result = await response.json();
      if (result.status === 400) {
        console.log(result.status.message);
        return;
      }
      setListingInfo(result);
      setSavedListingInfo(result)
      setSelectedPricingTier(result.pricing)
      let tempDemoReelCategories = []
      result.demoReels.map((reel, index) => tempDemoReelCategories.push(reel.category))
      setDemoReelCategories(tempDemoReelCategories)
    } catch (error) {
      console.log("something went wrong", error);
    }
  };


  useEffect(() => {
    if (userInfo && userInfo.listingId) {
      getListingInfo();
    }
  }, [userInfo]);

  useEffect(()=>{
    uploadVideo()
  },[videoFile])

  //use effect to set update listing button to disabled if listing is updating
  useEffect(()=>{
    document.getElementsByClassName('update-listing-button')[0].disabled = isListingUpdating
  },[isListingUpdating])

  
const checkIfExists = async(value, field)=>{
  let originalValue = ''
  if(field !== 'companyName' && field !== 'companyUrl') return
  if (field === 'companyName'){
    originalValue = savedListingInfo.companyName
  }
  if(field === 'companyUrl'){
    originalValue = savedListingInfo.companyUrl
  }
  const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
      const response = await fetch(
        `${API_BASE_URL}/check-if-exists`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, 
          },
          body: JSON.stringify({ field: field, value: value, originalValue: originalValue}),
        }
      );
      const result = await response.json();
      console.log(result.exists)
      if(field === 'companyName'){
      setIsNameBeingUsed(result.exists)
      }
      else if(field === 'companyUrl'){
        setIsUrlBeingUsed(result.exists)
      }
}


const handleChange = async(value, field)=>{

    checkIfExists(value, field)
        

    console.log(`${field} being set to ${value}`)
    let tempListingInfo = {...listingInfo}
    tempListingInfo[field] = value
    setListingInfo(tempListingInfo)
}

const handleChangePackageInfo = (value, packageIndex, field, packageDetailsIndex)=>{
  let tempListingInfo = {...listingInfo}
  if(field === 'packageDetails'){
    tempListingInfo.packages[packageIndex].packageDetails[packageDetailsIndex] = value
  }
  else{
    tempListingInfo.packages[packageIndex][field] = value
  }
  
  setListingInfo(tempListingInfo)
}

const handleFileChange = async (e) =>{
    const file = e.target.files[0]
    if (file && file?.name?.toLowerCase().endsWith('.mp4')) {
        setVideoFile(file);
      } 
      else if(!file?.name?.toLowerCase().endsWith('.mp4')){
        setIsModalOpen(true)
        setModalChildren(null)
        setModalSize('medium')
        setModalType('alert')
        setModalTitle("Invalid File Type")
        setModalDescription("You can only upload .mp4 files. Please upload a valid video file.")
        setModalConfirmButtonText('OK')
        setModalOnConfirm(() => () => {
          setIsModalOpen(false); 
        })
        setModalOnCancel(() => () => {
          setIsModalOpen(false);
        })
        setIsListingUpdating(false)
      }
      
}

const triggerVideoAnalysis = async(videoUrl, listingId, httpVideoUrl, videoName, companyName, companyUrl) =>{
  const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
  const response = await fetch(`${API_BASE_URL}/api/trigger-video-analysis`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Secure API secret
    },
    body: JSON.stringify({
      videoUrl: videoUrl,
      listingId: listingId,
      videoUrlForTransloadit: httpVideoUrl,
      videoName: videoName,
      companyName: companyName,
      companyUrl: companyUrl,
    }),
  });
  console.log('Video successfully analyzed and info stored!')
}

const uploadVideo = async()=>{
  
  if (isUploadInProgress || isUploading) return;
  
  setIsUploadInProgress(true);
  let hasUploaded = false;

    if (!videoFile) {
    console.log('No Video Found');
    setIsUploadInProgress(false); // Reset flag if no video file
    return;
  }
    
    const formData = new FormData();
    formData.append('video', videoFile);
    // videoFile.name with timestamp and listing ID appended to avoid overwriting existing files
    const videoFileName  = `${userInfo.listingId}_${Date.now()}_${videoFile.name}`;
    console.log(videoFileName)
    try{
      const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
      const response = await fetch(`${API_BASE_URL}/generate-signed-url`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Secure API secret
        },
        body: JSON.stringify({
          fileName: videoFileName,
          fileType: videoFile.type,
        }),
      });const { url } = await response.json();
      console.log('Signed Url:', url);
      setIsUploading(true);
      setUploadUrl(url);
      const xhr = new XMLHttpRequest();
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percentCompleted = Math.round((event.loaded * 100) / event.total);
          setProgress(percentCompleted);
        }
      };
    
      xhr.onload = () => {
        if (xhr.status === 200 && !hasUploaded) {
          hasUploaded = true;
          console.log('Upload successful!');
          setProgress(100);
          const bucketName = 'nxtvid_marketplace_listing_videos'; 
          const publicFileUrl = `https://storage.googleapis.com/${bucketName}/${videoFileName}`;
          const tempListingInfo  = {...listingInfo}
          const tempSavedListingInfo = {...savedListingInfo} // just so I can update their listingInfo in the DB, without pushing any changes other than the uploaded video
          const demoReelObject = {url: publicFileUrl, name: videoFile.name, fileName: videoFileName, category: 'Uncategorized'}
          if (!tempListingInfo.demoReels.includes(demoReelObject)) {
            tempListingInfo.demoReels.push(demoReelObject);
          }
          

          if (!tempSavedListingInfo.demoReels.includes(demoReelObject)) {
            tempSavedListingInfo.demoReels.push(demoReelObject);
          }
          
          setSavedListingInfo(tempSavedListingInfo)
          setListingInfo(tempListingInfo)
          handleUpdateVideoOnly(tempSavedListingInfo)
          
          triggerVideoAnalysis(`gs://${bucketName}/${videoFileName}`, userInfo.listingId, videoFileName, videoFileName, listingInfo.companyName, listingInfo.companyUrl)
        } else if(!hasUploaded){
          console.error('Upload failed:', xhr.statusText);
        }
        setIsUploading(false);
        setIsUploadInProgress(false);
      };
      xhr.onerror = () => {
        console.error('Network error during upload');
        setIsUploading(false);
        setIsUploadInProgress(false);
      };
      xhr.open('PUT', url, true);
      xhr.setRequestHeader('Content-Type', videoFile.type);
      xhr.send(videoFile);
    }catch(error){
      console.error('Error during upload:', error);
    setIsUploading(false);
    setIsUploadInProgress(false);
    }
}

useEffect(()=>{setModalChildren(
  <div className="save-listing-progress-modal">
    <div>
      {isListingUpdating ? 
      <p className="updating-message">{listingUpdatingText}</p>
      :
      <div className="Listing-Updated-Message">
        <h4>Listing Updated!</h4>
        <p>View your listing by following the link or clicking the button below.</p>
        <input className="listing-url-preview"  value={
          `https://nxtvid.io/Portfolios/${listingInfo?.companyUrl}`
        }/>
        <div>
        <Button label="Close" size = "medium" type='outline' onClick={()=>{setIsModalOpen(false)}}/>
        <Button label="View Listing" size='medium' type = "primary" onClick={()=>{
        window.open(`/Portfolios/${listingInfo?.companyUrl}`, '_blank')
        }}/>
    
      
        </div>
        </div>
      }
    
    </div>
  </div>
)}, [isListingUpdating, listingUpdatingText])

const handleSubmit = async () => {
  if(isListingUpdating) return
  setIsListingUpdating(true)
  
  // if block that checks if listingInfo.demoReels has multiple reels with the category "Director's Reel"
  let directorReelCount = 0
  demoReelCategories.map(reel => reel === `Director's Reel` ? directorReelCount++ : null)
  if(directorReelCount > 1){
    setIsModalOpen(true)
    setModalChildren(null)
    setModalSize('medium')
    setModalType('alert')
    setModalTitle("Director Reel Error")
    setModalDescription("You can only set one Director's Reel. Please remove the extra ones and try again.")
    setModalConfirmButtonText('OK')
    setModalOnConfirm(() => () => {
      setIsModalOpen(false); 
    })
    setModalOnCancel(() => () => {
      setIsModalOpen(false);
    })
    setIsListingUpdating(false)
    return
  }
  if(!listingInfo.companyName.trim() || isNameBeingUsed){
    setIsModalOpen(true)
    setModalChildren(null)
    setModalSize('medium')
    setModalType('alert')
    setModalTitle("Invalid Company Name")
    setModalDescription("You must enter a unique company name for your listing. Please enter one and try again.")
    setModalConfirmButtonText('OK')
    setModalOnConfirm(() => () => {
      setIsModalOpen(false); 
    })
    setModalOnCancel(() => () => {
      setIsModalOpen(false);
    })
    setIsListingUpdating(false)
    return
  }
  if(!listingInfo.companyUrl.trim() || isUrlBeingUsed){
    setIsModalOpen(true)
    setModalChildren(null)
    setModalSize('medium')
    setModalType('alert')
    setModalTitle("Invalid Company URL")
    setModalDescription("You must enter a unique company URL for your listing. Please enter one and try again.")
    setModalConfirmButtonText('OK')
    setModalOnConfirm(() => () => {
      setIsModalOpen(false); 
    })
    setModalOnCancel(() => () => {
      setIsModalOpen(false);
    })
    setIsListingUpdating(false)
    return
  }
  if(!listingInfo.about.trim()){
    setIsModalOpen(true)
    setModalChildren(null)
    setModalSize('medium')
    setModalType('alert')
    setModalTitle("Empty About Section")
    setModalDescription("You must include an about section in your listing. Please enter one and try again.")
    setModalConfirmButtonText('OK')
    setModalOnConfirm(() => () => {
      setIsModalOpen(false); 
    })
    setModalOnCancel(() => () => {
      setIsModalOpen(false);
    })
    setIsListingUpdating(false)
    return
  }
  
  setIsModalOpen(true)
  setModalOnCancel(()=>()=>{
    setIsModalOpen(false);
  })
  setModalChildren(
    <div className="save-listing-progress-modal">
        <p className="updating-message">{listingUpdatingText}</p>
    </div>
  )
  setModalSize('large')
  setModalType('blank')
  setModalTitle('')
  setModalDescription('')
  
  // Upload images and get URLs
  const logoUrl = await handleUploadImage('logo');
  const aboutImgUrl = await handleUploadImage('aboutImg');

  console.log('Logo URL:', logoUrl); // Debug: Check if this returns the expected URL
  console.log('About Image URL:', aboutImage); // Debug: Check if this returns the expected URL
  console.log(`About img: ${aboutImg}`)


  // Create a temporary listingInfo object with updated image URLs
  const tempListingInfo = { ...listingInfo };
  if (logoUrl) {
    tempListingInfo.companyLogo = logoUrl;
  }
  if (aboutImgUrl) {
    tempListingInfo.aboutImg = aboutImgUrl;
  }
  if(selectedPricingTier){
    tempListingInfo.pricing = selectedPricingTier;
  }
  setListingInfo(tempListingInfo);
  console.log("tempListingInfo before API call:", tempListingInfo);

  try {
    if (!userInfo?.listingId) return;
    const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
    const response = await fetch(`${API_BASE_URL}/api/updateListingInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Secure API secret
      },
      body: JSON.stringify({ listingInfo: tempListingInfo, listingId: userInfo.listingId }),
    });
    
    const result = await response.json();
    if (result.status === 400) {
      console.log(result.message);
      setIsListingUpdating(false)
      return;
    }
    setIsListingUpdating(false)
  } catch (error) {
    setIsListingUpdating(false)
    console.log("Something went wrong", error);
  }
};


const updateListingText = () =>{
  let text = 'Updating Listing.'
  let count = 0
  intervalId = setInterval(()=>{
    if(count === 0){
      text = 'Updating Listing.'
      count++
    }
    else if(count === 1){
      text = 'Updating Listing..'
      count++
    }
    else if(count === 2){
      text = 'Updating Listing...'
      count = 0
    }
    setListingUpdatingText(text)
  }, 1000)
}

useEffect(() => {
  if (isListingUpdating) {
    updateListingText();
  } else {
    clearInterval(intervalId);
  }

  // Cleanup interval on component unmount
  return () => clearInterval(intervalId);
}, [isListingUpdating]);

const UpdatingListingCard = () =>{
  return(
    <div className="updating-listing-card">
      <div>
        {isListingUpdating ? 
        <p className="updating-message">{listingUpdatingText}</p>
        :
        <div className="Listing-Updated-Message">
          <h4>Listing Updated!</h4>
          <p>View your listing by following the link or clicking the button below.</p>
          <input className="listing-url-preview"  value={
            `https://nxtvid.io/Portfolios/${listingInfo.companyUrl}`
          }/>
          <div>
          <Button label="Close" size = "medium" type='outline' onClick={()=>{setIsListingUpdatingCardVisible(false)}}/>
          <Button label="View Listing" size='medium' type = "primary" onClick={()=>{
          window.open(`/Portfolios/${listingInfo.companyUrl}`, '_blank')
          }}/>
      
        
          </div>
          </div>
        }
      
      </div>
    </div>
  )
}

const handleUpdateVideoOnly = async (tempSavedListingInfo) => {
  try {
      if (!userInfo?.listingId) return; // Ensure listingId is valid
      const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
      const response = await fetch(`${API_BASE_URL}/api/updateListingInfo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Secure API secret
        },
        body: JSON.stringify({ listingInfo:tempSavedListingInfo, listingId:userInfo.listingId }),
      });
      const result = await response.json();
      if (result.status === 400) {
        console.log(result.status.message);
        return;
      }
      
    } catch (error) {
      console.log("something went wrong", error);
    }
}

const previewProfileImage = (event) => {
  const file = event.target.files[0];
  const tempListingInfo = { ...listingInfo };

  if (file) {
    
    const objectUrl = URL.createObjectURL(file);
    tempListingInfo.companyLogo = objectUrl;
    setListingInfo(tempListingInfo);
    setLogo(file)
    setLogoUrl(objectUrl)
    setNewLogo(true)
    return () => URL.revokeObjectURL(objectUrl);
  }
};

const handleDeleteVideo = async(reel) =>{
  let tempSavedListingInfo = {...savedListingInfo}
  let tempListingInfo = {...listingInfo}
  let demoReelsArray = tempSavedListingInfo.demoReels
  demoReelsArray = demoReelsArray.filter(demoReel => demoReel != demoReelsArray[reel])
  tempSavedListingInfo.demoReels = demoReelsArray
  tempListingInfo.demoReels = demoReelsArray
  
  const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
    const response = await fetch(`${API_BASE_URL}/api/deleteVideo`, {
       method: "POST",
       headers: {
          "Content-Type": "application/json",
          "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Secure API secret
        },
        body: JSON.stringify({ listingInfo:tempSavedListingInfo, listingId:userInfo.listingId, index:reel }),
        });
        const result = await response.json();
        if (result.status === 400 || result.status === 500) {
          console.log(result.status.message);
          return;
        }
        setIsModalOpen(true)
        setModalChildren(null)
        setModalSize('medium')
        setModalType('alert')
        setModalTitle("Successfully Deleted Video")
        setModalDescription("Demo Reel and all associated video clips have successfully been deleted")
        setModalConfirmButtonText('OK')
        setModalOnConfirm(() => () => {
          setIsModalOpen(false); 
        })
        setModalOnCancel(() => () => {
          setIsModalOpen(false);
        })
        setListingInfo(tempListingInfo)
        setSavedListingInfo(tempSavedListingInfo)
}

const handleChangeAboutImage = (e) =>{
  const file = e.target.files[0];
  const tempListingInfo = { ...listingInfo };

  if (file) {
    const objectUrl = URL.createObjectURL(file);
    tempListingInfo.aboutImg = objectUrl;
    setListingInfo(tempListingInfo);
    setAboutImgUrl(objectUrl)
    setAboutImage(file)
    setNewAboutImage(true)
    return () => URL.revokeObjectURL(objectUrl);
  }
}


const handleScroll = () => {
  const offset = 120;
  const sectionPosition = targetSection.current.getBoundingClientRect().top + window.scrollY;
  
  window.scrollTo({
    top: sectionPosition - offset,
    behavior: 'smooth',
  });
};

const uploadImageToGCS = async (file, type) => {
  const fileName = `${userInfo.listingId}_${type}`;
  console.log(`fileName: ${fileName}`);
  const bucketName = "nxtvid-user-about-images"
  const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
  console.log(`fileName: ${fileName}, bucketName: ${bucketName}, file: ${file}`);

  const formData = new FormData();
  formData.append('image', file);
  formData.append('bucketName', bucketName);
  formData.append('fileName', fileName);

  try {
    const response = await fetch(`${API_BASE_URL}/api/optimizeAndUploadImage`, {
      method: "POST",
      headers: {
        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Secure API secret
      },
      body: formData
    });

    const data = await response.json();

    if (!data.publicUrl) {
      throw new Error('Failed to upload image to GCS');
    }

    return data.publicUrl;
  } catch (error) {
    console.error('Error uploading image:', error);
    return null;
  }
};

const handleUploadImage = async (imageType) => {
  if (imageType === 'logo') {
    const publicUrl = await uploadImageToGCS(logo, "logo");
  if (publicUrl) {
    return publicUrl;
  } else {
    console.log('Failed to upload image');
  }
  }
  else if(imageType === 'aboutImg'){
    console.log('aboutImg:', aboutImage);
    const publicUrl = await uploadImageToGCS(aboutImage,"aboutImg");
  if (publicUrl) {
    return publicUrl;
  } else {
    console.log('Failed to upload image');
  }
  }

  
};

const handleChangeClients = (value, index) =>{
  const tempListingInfo = {...listingInfo}
  tempListingInfo.clients[index] = value
  setListingInfo(tempListingInfo)
}

const handleDeleteClients = (index) =>{
  console.log(`Deleting client at index ${index}`)
  const tempListingInfo = {...listingInfo}
  tempListingInfo.clients = tempListingInfo.clients.filter((client, i) => i.toString() !== index)
  console.log(`New clients array: ${tempListingInfo.clients}`)
  setListingInfo(tempListingInfo)
}

const handleDeleteVideoClick = (video)=>{
  setModalSize('medium');
  setSelectedVideo(video); 
  setIsModalOpen(true)
  setModalType('confirm')
  setModalChildren(null)
  setModalTitle('Delete Video')
  setModalDescription('Are you sure you want to delete this file? This action is irreversable.')
  setModalOnConfirm(()=>()=>{
    handleDeleteVideo(video);
    setIsModalOpen(false); 
  })
  setModalOnCancel(()=>()=>{
    setIsModalOpen(false);
  })
  setModalCancelButtonText('Cancel')
  setModalConfirmButtonText('Delete')
}

useEffect(() => {
  const handleKeyDown = (event) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 's') {
      event.preventDefault(); 
      handleSubmit(); 
    }
  };
  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [listingInfo, demoReelCategories, isNameBeingUsed, isUrlBeingUsed]);



  
return (
    <div>
      {isModalOpen ? <Modal children={modalChildren} size={modalSize} type={modalType} title={modalTitle} description={modalDescription} onConfirm={modalOnConfirm} onClose={modalOnCancel} confirm_button_text={modalConfirmButtonText} cancel_button_text={modalCancelButtonText}/> : null}
           
      <div className="App-body-listing-editor">
      <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
        {isListingUpdatingCardVisible ? <UpdatingListingCard/> : null}
        <div className="listingEditorCard">
          <div className='listing-editor-left-side'>
            <div className="Main-Info-Section">
              <div className="flex-container-column profile-image-and-checkboxes">
              <div className='logo-upload' onClick={() => document.getElementById('logoInput').click()} >
              <input type='file' id='logoInput' accept="image/*" onChange={(e)=>{previewProfileImage(e)}} />
              <div className="image-preview" id="imagePreview">
              {listingInfo?.companyLogo ? <img className="company-logo-listing-editor" alt={`${listingInfo?.companyName}'s Logo`} src={newLogo ? logoUrl : logo}/> : null}
              <img className="upload-icon" alt="upload icon" src={uploadIcon}/>
              </div>
            </div>
              <label className="checkbox-label">
          Cities
          <ul className="checkbox-items">
            {cities.map(city =>  <li className="checkbox-item"><div className={`checkbox-box ${listingInfo?.location.includes(city) ? "checked" : ""}`} onClick={()=>{const tempListingInfo = {...listingInfo}; tempListingInfo.location.includes(city) ? tempListingInfo.location = tempListingInfo.location.filter(item=>item!==city):tempListingInfo.location.push(city); setListingInfo(tempListingInfo)}}/>{city}</li>)}
          </ul>
        </label>
        
        <label className="checkbox-label">
          Pricing Tier
          <div>
          <Dropdown border dropdownOptions = {pricingTiers} selected={selectedPricingTier} setSelected={setSelectedPricingTier}/>
          </div>
          <p className="manage-packages-button" onClick={handleScroll}>Manage packages</p>
          </label>
          <Button className={'update-listing-button'} label="Update Listing" size='large' type='primary' onClick={()=>{handleSubmit()}}/>
              </div>
            
            <div className="flex-container-column name-about-section">
              {isNameBeingUsed ? <p className="name-in-use-status">Name already in use</p> : null}
              <input type="text" onChange={(e)=>{handleChange(e.target.value, "companyName")}} placeholder="Company Name" value={listingInfo?.companyName || ""} />
              
              <div className="flex-container-row url-container">
              {isUrlBeingUsed ? <p className="url-in-use-status">URL already in use</p> : null}
                <p className="url-label url-label1">https://nxtvid.io/Portfolios/</p>
                <p className="url-label url-label2">nxtvid.io/Portfolios/</p>
                <input type="text" onChange={(e)=>{handleChange(e.target.value, "companyUrl")}} placeholder="Company URL" value={listingInfo?.companyUrl || ""} />
              </div>
              <textarea spellcheck="false" type="text" rows={20} onChange={(e)=>{handleChange(e.target.value, "about")}} placeholder="About" value={listingInfo?.about || ""} />
              <div className="about-image-wrapper">
              <p className="change-about-image-button" onClick={() => document.getElementById('aboutImgInput').click()}>Change "About" Image</p>
              <div className="about-image-preview">
                <img className="about-img" src={newAboutImage ? aboutImgUrl : aboutImg} alt={`About ${listingInfo?.companyName} `} />
              </div>
              <input type='file' id='aboutImgInput' accept="image/*" onChange={(e)=>{handleChangeAboutImage(e)}} />
              </div>
            </div>
            </div>
          </div>
        <div className = 'listing-editor-right-side'>
          
        <div className="flex-container-column Demo-Reel-Upload">
        <label className="checkbox-label">Demo Reels
        </label>

          <div className="files-list">
          
          {listingInfo?.demoReels.map((reel,index)=>{
            return <div key={reel.fileName}>
              <input placeholder="Video Name" value={reel.name} onChange={(e)=>{
                const tempListingInfo = {...listingInfo}
                tempListingInfo.demoReels[index].name = e.target.value
                setListingInfo(tempListingInfo)
              }}/>
              <Dropdown dropdownOptions={['Uncategorized', `Director's Reel`, `Event`, `Food & Beverage`, `Product`]} selected={reel.category} setSelected={(value)=>setListingInfo((prev)=>{ const updatedReels = [...prev.demoReels]; updatedReels[index] = {...updatedReels[index], category: value,}; return{...prev, demoReels: updatedReels}})} carrot border/>
              <div className="Files-Elipses"><p>...</p>
                <div  className="file-settings">
                  <p id={reel.fileName} onClick={(e)=>viewVideo(e.target.id)}>View</p>
                  <p id={index} onClick={(e)=>{handleDeleteVideoClick(e.target.id)}}>Delete</p>
                  </div>
                  
              </div>
              </div>
          })}
          {isUploading && (
        <div>
          <progress value={progress} max="100" />
          <p>{progress}%</p>
        </div>
      )}
          <label>
            <p className="NXTVid-Purple add-client-or-demoreel-button" >+</p>
            <input type="file" id="add-video" accept=".mp4" onChange={(handleFileChange)} />
          </label>
          
          </div>
          

        
        </div>
        <div className="clients-editor">
          <label className="list-label checkbox-label">
          Clients
          </label>
          <ul className="clients-list">
            {listingInfo?.clients.map((client,index) =>  <li><input type='text' value={client} placeholder="Client Name" onChange={(e)=>handleChangeClients(e.target.value, index)}/><p id={`Delete-Button-${index}`} className="NXTVid-Orange" onClick={(e)=>{e.preventDefault(); handleDeleteClients(e.target.id.substring(14))}}>-</p></li>)}
            {listingInfo?.clients.length < 9 ? <label className="width-100"><p className="NXTVid-Purple add-client-or-demoreel-button" onClick={(e)=>{
              e.preventDefault();
              const tempListingInfo = {...listingInfo}
              tempListingInfo.clients.push('')
              setListingInfo(tempListingInfo)
            }}>+</p></label> : null}
          </ul>
        
          </div>
       
        </div>
        
      </div>

      <div className=' listing-editor-packages' ref={targetSection} >
          <h3 className="pricing-header">Packages</h3>
          <div className="packages-toggle">
            <p>Show Packages on Portfolio Page</p>
            <ToggleButton onClick={handleTogglePackagesVisibility} isActive={listingInfo?.packagesVisible}/>
          </div>
          <div className='package-options'>
          <div className='package-option'>
            <input className="package-name packages-input" placeholder="Package Name" onChange={(e)=>handleChangePackageInfo(e.target.value, 0, 'packageName', null)} value={listingInfo?.packages[0].packageName}/>
            <input className="package-cost packages-input"  onChange={(e)=>handleChangePackageInfo(e.target.value.substring(1), 0, 'packageCost', null)} value={`$${listingInfo?.packages[0].packageCost}`}/>
            <div className="details-section">
              <input className="package-description packages-input" placeholder="Package Description" onChange={(e)=>handleChangePackageInfo(e.target.value, 0, 'packageDescription', null)} value={`${listingInfo?.packages[0].packageDescription}`}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 0, 'packageDetails', 0)} value={listingInfo?.packages[0].packageDetails[0]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 0, 'packageDetails', 1)} value={listingInfo?.packages[0].packageDetails[1]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 0, 'packageDetails', 2)} value={listingInfo?.packages[0].packageDetails[2]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 0, 'packageDetails', 3)} value={listingInfo?.packages[0].packageDetails[3]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 0, 'packageDetails', 4)} value={listingInfo?.packages[0].packageDetails[4]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 0, 'packageDetails', 5)} value={listingInfo?.packages[0].packageDetails[5]}/>
            </div>
          </div>
          <div className='package-option'>
          <input className="package-name packages-input" placeholder="Package Name" onChange={(e)=>handleChangePackageInfo(e.target.value, 1, 'packageName', null)}  value={listingInfo?.packages[1].packageName}/>
            <input className="package-cost packages-input"  onChange={(e)=>handleChangePackageInfo(e.target.value.substring(1), 1, 'packageCost', null)} value={`$${listingInfo?.packages[1].packageCost}`}/>
            <div className="details-section">
              <input className="package-description packages-input" placeholder="Package Description" onChange={(e)=>handleChangePackageInfo(e.target.value, 1, 'packageDescription', null)} value={`${listingInfo?.packages[1].packageDescription}`}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 1, 'packageDetails', 0)} value={listingInfo?.packages[1].packageDetails[0]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 1, 'packageDetails', 1)} value={listingInfo?.packages[1].packageDetails[1]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 1, 'packageDetails', 2)} value={listingInfo?.packages[1].packageDetails[2]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 1, 'packageDetails', 3)} value={listingInfo?.packages[1].packageDetails[3]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 1, 'packageDetails', 4)} value={listingInfo?.packages[1].packageDetails[4]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 1, 'packageDetails', 5)} value={listingInfo?.packages[1].packageDetails[5]}/>
            </div>
          </div>
          <div className='package-option'>
          <input className="package-name packages-input" placeholder="Package Name" onChange={(e)=>handleChangePackageInfo(e.target.value, 2, 'packageName', null)} value={listingInfo?.packages[2].packageName}/>
            <input className="package-cost packages-input"  onChange={(e)=>handleChangePackageInfo(e.target.value.substring(1), 2, 'packageCost', null)} value={`$${listingInfo?.packages[2].packageCost}`}/>
            <div className="details-section">
              <input className="package-description packages-input" placeholder="Package Description" onChange={(e)=>handleChangePackageInfo(e.target.value, 2, 'packageDescription', null)} value={`${listingInfo?.packages[2].packageDescription}`}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 2, 'packageDetails', 0)} value={listingInfo?.packages[2].packageDetails[0]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 2, 'packageDetails', 1)} value={listingInfo?.packages[2].packageDetails[1]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 2, 'packageDetails', 2)} value={listingInfo?.packages[2].packageDetails[2]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 2, 'packageDetails', 3)} value={listingInfo?.packages[2].packageDetails[3]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 2, 'packageDetails', 4)} value={listingInfo?.packages[2].packageDetails[4]}/>
              <input className="packages-input" onChange={(e)=>handleChangePackageInfo(e.target.value, 2, 'packageDetails', 5)} value={listingInfo?.packages[2].packageDetails[5]}/>
            </div>
          
          </div>
          </div>
        </div>
        <Button className={'update-listing-button under-packages-submit'} label="Update Listing" onClick={()=>{handleSubmit()}}/>
        </div>
    </div>
  );
};

export default ListingEditor;
